import app, { Component, on } from 'apprun';
import {registration} from './api';
import {validator} from './api';

import {isValid} from './utils';
import {MessageComponent} from './message';

import _,{lang, setLanguage}  from './l10n';

const ThankYouMessage = ()=>{
  let ThanksMessage;
    if(lang == 'fr-ca'){
      ThanksMessage = '_html:<form><div><h3>Merci de votre inscription auprès de RPS !</h3><p>Vous recevrez sous peu un message électronique de confirmation qui vous permettra de créer un nom d’utilisateur et un mot de passe, ainsi que de vous connecter au Portail évaluateur RPS.</p><p>Dans le Portail évaluateur RPS, vous pourrez indiquer vos zones de service, vos prix et d’autres renseignements importants, configurer le compte des évaluateurs de votre entreprise, le cas échéant, ainsi que créer un contrat avec nous.</p><p>Nous sommes impatients de travailler avec vous et avons informé l’équipe de soutien RPS.</p><p>Si vous avez besoin d’assistance immédiate, écrivez-nous à <a href=\'mailto:appraisersupport@rpsrealsolutions.com\'>appraisersupport@rpsrealsolutions.com</a>.</p></div></form>'
    }else{
      ThanksMessage = '_html:<form><div><h3>Thank you for signing up with RPS!</h3> <p>A confirmation email will be sent to you shortly, which will also allow you to create a user name and password as well as login to the RPS Appraiser Portal. </p><p>In the RPS Appraiser Portal, you will be able to provide us with coverage, pricing and other important information, set up any appraisers in your firm, as well as create a contract with us.</p><p>We look forward to working with you and have notified the RPS support team.</p><p>Should you require any immediate assistance, send us an email at <a href=\'mailto:appraisersupport@rpsrealsolutions.com\'>appraisersupport@rpsrealsolutions.com</a>.</p></div></form>'
    }
  return ThanksMessage;
}

export default class RegistrationComponent extends Component {
  state = {
    firmName: '',
    tradeName: '',
    firmAddress: '',
    city: '',
    province: '',
    postalcode: '',
    firmPhone: '',
    firmEmail: '',
    firstName: '',
    lastName: '',
    userName: '',
    password: '',
    showMessage: false,

  };

  view = state => {

    let ThanksMessage;

    let provinceEnList = 
    <><option value="AB">Alberta</option>
    <option value="BC">British Columbia</option>
    <option value="MB">Manitoba</option>
    <option value="NB">New Brunswick</option>
    <option value="NF">Newfoundland and Labrador</option>
    <option value="NS">Nova Scotia</option>
    <option value="ON">Ontario</option>
    <option value="PE">Prince Edward Island</option>
    <option value="PQ">Quebec</option>
    <option value="SK">Saskatchewan</option>
    <option value="NW">Northwest Territories</option>
    <option value="NU">Nunavut</option>
    <option value="YT">Yukon</option></>;
    
    let provinceFrList = 
    <><option value="AB">Alberta</option>
    <option value="BC">Colombie-Britannique</option>
    <option value="PE">Île-du-Prince-Édouard</option>
    <option value="MB">Manitoba</option>
    <option value="NB">Nouveau-Brunswick</option>
    <option value="NS">Nouvelle-Écosse</option>
    <option value="ON">Ontario</option>
    <option value="PQ">Québec</option>
    <option value="SK">Saskatchewan</option>
    <option value="NF">Terre-Neuve-et-Labrador</option>
    <option value="NU">Nunavut</option>
    <option value="NW">Territoires du Nord-Ouest</option>
    <option value="YT">Yukon</option></>;

    if(lang == 'fr-ca'){
      ThanksMessage = '_html:Merci de votre inscription auprès de RPS. Ce formulaire de préinscription doit être rempli <b>par le propriétaire</b> de l’entreprise d’évaluation. Tous les renseignements sont requis.';
    }else{
      ThanksMessage = '_html:Thank you for signing up with RPS. This pre-registration form is to be completed <b>by the owner</b> of the appraisal firm. All information is required.';
    }
      
    return (
      
      <div className = "row">

        {state.showMessage ?
        <ThankYouMessage/>
      :
<form id="RgistrationForm">   

<div>
<h2>{_('New Appraisal Firm Sign Up')}</h2>
<p>{ThanksMessage}</p>
{
   
}
<div id="RgistrationFormErrorSummary" className="text-danger ng-isolate-scope alert-danger" ></div>

<table className="table table-condensed table-bordered table-striped table-hover" >
  <tbody>
  <tr><th className="ng-scope" colSpan = "2"><h5>{_('Firm Name')}</h5></th></tr>
  <tr>
    <td className="ng-scope">{_('Legal Name of Firm')} | <i>{_('As per the Company Registration or Sole Proprietor Registration')}</i></td>
    <td className="ng-binding"><input type="text" name="firmName" id="firmName" displayFieldName = {_('Legal Name of Firm')} required="required" data-validate className='pull-left' oninput={e=> this.run('binding', e) } size="40"></input></td>
  </tr>
  
  <tr>
    <td className="ng-scope">{_('Trade or Operating Name of Firm')} | <i>{_('Doing Business As (DBA)')}</i></td>
    <td className="ng-binding"><input type="text" name="tradeName" id="tradeName" displayFieldName = {_('Trade or Operating Name of Firm')} required="required" data-validate className='pull-left' oninput={e=> this.run('binding', e) } size="40"></input></td>
  </tr>

  <tr><th className="ng-scope" colSpan = "2"><h5>{_('Firm Address')}</h5></th></tr>
  
  <tr>
    <td className="ng-scope">{_('Address')}</td>
    <td className="ng-binding"><input type="text" name="firmAddress" id="firmAddress"  displayFieldName = {_('Address')} required="required" data-validate className='pull-left' oninput={e=> this.run('binding', e) }  size="40"></input></td>
  </tr>
  
  <tr>
    <td className="ng-scope">{_('City')}</td>
    <td className="ng-binding"><input type="text" name="city" id="city" displayFieldName = {_('City')} required="required" data-validate className='pull-left' oninput={e=> this.run('binding', e) }></input></td>
  </tr>
  
  <tr>
    <td className="ng-scope">{_('Province')}</td>
    <td className="ng-binding">
    <select name="province" id="province" required="required" displayFieldName = {_('Province')} data-validate className='pull-left' oninput={e=> this.run('binding', e) }>
    <option value=""></option>
    { lang == 'fr-ca' ? provinceFrList: provinceEnList}    
    </select>	
    </td>
  </tr>
  
  <tr>
    <td className="ng-scope">{_('Postal Code')}</td>
    <td className="ng-binding"><input type="text" name="postalcode" id="postalcode" displayFieldName = {_('Postal Code')} required="required" data-validate="PCode" className='pull-left' oninput={e=> this.run('binding', e) }></input></td>
  </tr>

  <tr><th className="ng-scope" colSpan = "2"><h5>{_('Owner\'s Contact Information')}</h5></th></tr>

  <tr>
    <td className="ng-scope">{_('First Name')}</td>
    <td className="ng-binding"><input type="text" name="firstName" id="firstName" displayFieldName ={_('First Name')} required="required" data-validate className='pull-left' oninput={e=> this.run('binding', e) }></input></td>
  </tr>
  <tr>
    <td className="ng-scope">{_('Last Name')}</td>
    <td className="ng-binding"><input type="text" name="lastName" id="lastName" displayFieldName = {_('Last Name')} required="required" data-validate className='pull-left' oninput={e=> this.run('binding', e) }></input></td>
  </tr>
  <tr>
    <td className="ng-scope">{_('Phone Number')}</td>
    <td className="ng-binding"><input type="text" name="firmPhone" id="firmPhone" displayFieldName = {_('Phone Number')} required="required" data-validate="Phone" className='pull-left' oninput={e=> this.run('binding', e) }></input></td>
  </tr>
  <tr>
    <td className="ng-scope">{_('Email Address/User Name')}</td>
    <td className="ng-binding"><input type="text" name="firmEmail" id="firmEmail" displayFieldName = {_('Email Address/User Name')} required="required" data-validate="email" className='pull-left' oninput={e=> this.run('binding', e) }></input></td>
  </tr>
  
  </tbody>          
</table>
<p></p>
<button type="button" id="submitBtn" onclick={e => this.run('signup', e)} className="btn btn-default btn-icon" >{_('Sign Up')}</button>

</div>

</form>
        }
      </div>
    );
  };

  update = {
    '#': state => { 
      var lang = location.search.split('lang=')[1];

      if(lang){
        if(lang == 'fr')
          setLanguage('fr-ca');
        else
          setLanguage('en-ca');
      }

      return state;
    },
     signup: async (state, e) => {
        const formName='RgistrationForm';        
        if (!isValid(formName)) return;

        
        state.disableSubmit= true;

        document.getElementById("submitBtn").setAttribute("disabled", "disabled");

        let theRegistration = await registration.signup(state);    
      
        document.getElementById("submitBtn").removeAttribute("disabled");

        if(theRegistration.length == 0)
        {
          state.showMessage = true;
          return state;
        }else{
          let validationSummary = "";
          for (var i = 0; i < theRegistration.length; i++){
            validationSummary += '<p>'+theRegistration[i].Message+'</p>';
          }

          let errSummaryDiv = document.getElementById('RgistrationFormErrorSummary') as HTMLDivElement;
  
          if(validationSummary){
            errSummaryDiv.innerHTML = validationSummary;
            errSummaryDiv.style.display = "block";
          }

          return ;
        }        
    },
      
    binding: (state, e) => {
      state[e.target.id] = e.target.value;
      return state;
    }

  };

  private testMethod(state, user) {
    return null;
  }
}

new RegistrationComponent().mount('assr-app');
